import { RedoOutlined, SaveOutlined, UndoOutlined } from '@ant-design/icons'
import { Button, Divider, Tag, Tooltip } from 'antd'

import cn from '../PrioritySortShared.module.scss'

interface PrioritySaveBarProps {
  changeCount: number
  onSave: () => void
  onUndo: () => void
  onRedo: () => void
  canUndo: boolean
  canRedo: boolean
  loading?: boolean
  isBlueTheme?: boolean
}

export const PrioritySaveBar = ({
  changeCount,
  onSave,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  loading = false,
  isBlueTheme = false,
}: PrioritySaveBarProps) => {
  if (changeCount === 0) return null

  return (
    <div
      className={`${cn.saveFloatingBar} ${isBlueTheme ? cn.saveFloatingBarBlueTheme : ''}`}
    >
      <div className={cn.globalActions}>
        <Tooltip title="Отменить">
          <Button
            icon={<UndoOutlined />}
            onClick={onUndo}
            disabled={!canUndo}
          />
        </Tooltip>
        <Tooltip title="Вернуть">
          <Button
            icon={<RedoOutlined />}
            onClick={onRedo}
            disabled={!canRedo}
          />
        </Tooltip>
      </div>
      <Divider type="vertical" className={cn.saveBarDivider} />
      <Tag color="orange" className={cn.changeTag}>
        Изменений: {changeCount}
      </Tag>
      <Button
        type="primary"
        size="large"
        icon={<SaveOutlined />}
        onClick={onSave}
        loading={loading}
        className={cn.saveBtn}
      >
        Сохранить
      </Button>
    </div>
  )
}
